export default class InformationPillController {
  /* @ngInject */
  // constructor() { }
  inverted() {
    return this.isInverted ? 'inverted' : 'default';
  }
  borderType(type) {
    return this.border ? `border-${type}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/components/information-pill/information-pill.controller.js